import { faArrowDown, faArrowUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import React from "react";
import RecipeBadges from "./RecipeBadges";

const RecipeBadgeDetails = ({ badges }) => {
  const [badgesOpen, setBadgesOpen] = useState(false);

  const handleBadgesToggle = () => {
    setBadgesOpen(!badgesOpen);
  };

  return (
    <section className="Background-LGreen">
      <div className="Badge-Title Row Space-B">
        <h4>Badges</h4>
        <button className="Dark-Gray" onClick={handleBadgesToggle}>
          <FontAwesomeIcon icon={badgesOpen ? faArrowUp : faArrowDown} />
        </button>
      </div>
      {badgesOpen && (
        <div className="Row Space-E p1 Div-Parent-Badge">
          {badges.map((badge, index) => (
            <RecipeBadges
              key={badge.id || `badge-${index}`}
              badge={badge}
              header={false}
            />
          ))}
        </div>
      )}
    </section>
  );
};

export default RecipeBadgeDetails;
